export const SPACES_NO_WALL = [
    "SHOWROOM_SMALL",
    "SHOWROOM_SMALL",
    "SHOWROOM_VERY_SMALL",
    "SHOWROOM_NORMAL",
    "SHOWROOM_LARGE",
    "SHOWROOM_BIG",
    "SHOWROOM_SUPER_BIG",
    "SHOWROOM_NETWORKING",
    "SHOWROOM_SUPER_OFFICE",
    "SHOWROOM_INVESTIGATION",
    "SHOWROOM_SUPER_BIG_WITH_NETWORKING_NO_WALL",
    "SHOWROOM_TROPICAL",
]

